import { TdsDivider } from '@scania/tegel-react';

const Divider = () => {
  return (
    <>
      <div className="tds-headline-02 tds-u-pb1">Divider</div>
      <TdsDivider></TdsDivider>
    </>
  );
};

export default Divider;
